export const UNALERT_BUTTON = 'unalert.button';
export const UNALERT_TITLE = 'unalert.title';
